import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CalculatorIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M8.88889 6.11111C9.44117 6.11111 9.88889 6.55883 9.88889 7.11111V7.88889H10.6667C11.219 7.88889 11.6667 8.3366 11.6667 8.88889C11.6667 9.44117 11.219 9.88889 10.6667 9.88889H9.88889V10.6667C9.88889 11.219 9.44117 11.6667 8.88889 11.6667C8.3366 11.6667 7.88889 11.219 7.88889 10.6667V9.88889H7.11111C6.55883 9.88889 6.11111 9.44117 6.11111 8.88889C6.11111 8.3366 6.55883 7.88889 7.11111 7.88889H7.88889V7.11111C7.88889 6.55883 8.3366 6.11111 8.88889 6.11111ZM16.1818 6.404C16.5723 6.01348 17.2055 6.01348 17.596 6.404C17.9865 6.79453 17.9865 7.42769 17.596 7.81822L7.81822 17.596C7.42769 17.9865 6.79453 17.9865 6.404 17.596C6.01348 17.2055 6.01348 16.5723 6.404 16.1818L16.1818 6.404ZM12.3333 15.1111C12.3333 14.5588 12.781 14.1111 13.3333 14.1111H16.8889C17.4412 14.1111 17.8889 14.5588 17.8889 15.1111C17.8889 15.6634 17.4412 16.1111 16.8889 16.1111H13.3333C12.781 16.1111 12.3333 15.6634 12.3333 15.1111Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3 6.4C3 4.52223 4.52223 3 6.4 3H17.6C19.4778 3 21 4.52223 21 6.4V17.6C21 19.4778 19.4778 21 17.6 21H6.4C4.52223 21 3 19.4778 3 17.6V6.4ZM6.4 5C5.6268 5 5 5.6268 5 6.4V17.6C5 18.3732 5.6268 19 6.4 19H17.6C18.3732 19 19 18.3732 19 17.6V6.4C19 5.6268 18.3732 5 17.6 5H6.4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

CalculatorIcon.propTypes = {
  ...sizePropsTypes,
};

export default CalculatorIcon;
